import * as Types from './types.generated';

import gql from 'graphql-tag';
import { AssetFieldsFragmentDoc } from './fragments/asset.generated';
import { SeoFieldsFragmentDoc } from './components/componentSeo.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GameGuideFragment = { __typename: 'PageGame', title?: string | null, urlSlug?: string | null, sys: { __typename: 'Sys', firstPublishedAt?: any | null }, mainImage?: { __typename: 'Asset', url?: string | null } | null, gameTagsCollection?: { __typename: 'PageGameGameTagsCollection', items: Array<{ __typename: 'ComponentGameTag', name?: string | null } | null> } | null };

export type GamingGuidesOverviewPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GamingGuidesOverviewPageQuery = { __typename: 'Query', pageGamingGuidesOverviewCollection?: { __typename: 'PageGamingGuidesOverviewCollection', items: Array<{ __typename: 'PageGamingGuidesOverview', title?: string | null, metaTitle?: string | null, metaDescription?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, keywords?: string | null, ogImage?: { __typename: 'Asset', title?: string | null, description?: string | null, width?: number | null, height?: number | null, url?: string | null } | null, subtitle?: { __typename: 'PageGamingGuidesOverviewSubtitle', json: any } | null, linkedSeoTags?: { __typename: 'ComponentSeoTags', title?: string | null, description?: string | null, keywords?: string | null, noFollow?: boolean | null, noIndex?: boolean | null } | null } | null> } | null, pageGameCollection?: { __typename: 'PageGameCollection', items: Array<{ __typename: 'PageGame', title?: string | null, urlSlug?: string | null, sys: { __typename: 'Sys', firstPublishedAt?: any | null }, mainImage?: { __typename: 'Asset', url?: string | null } | null, gameTagsCollection?: { __typename: 'PageGameGameTagsCollection', items: Array<{ __typename: 'ComponentGameTag', name?: string | null } | null> } | null } | null> } | null };

export const GameGuideFragmentDoc = gql`
    fragment gameGuide on PageGame {
  sys {
    firstPublishedAt
  }
  title
  urlSlug
  mainImage {
    url
  }
  gameTagsCollection {
    items {
      name
    }
  }
}
    `;
export const GamingGuidesOverviewPageDocument = gql`
    query gamingGuidesOverviewPage {
  pageGamingGuidesOverviewCollection(limit: 1) {
    items {
      title
      metaTitle
      metaDescription
      ogImage {
        ...assetFields
      }
      noFollow
      noIndex
      keywords
      subtitle {
        json
      }
      linkedSeoTags {
        ...seoFields
      }
    }
  }
  pageGameCollection(
    where: {linkedAcademyCategory_exists: true}
    order: title_ASC
  ) {
    items {
      ...gameGuide
    }
  }
}
    ${AssetFieldsFragmentDoc}
${SeoFieldsFragmentDoc}
${GameGuideFragmentDoc}`;